import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const GreetingBanner = (props) => {
    const { ownersName } = props;

    if (!ownersName) return null;

    return (
        <div className="greetings-banner">
            <FormattedMessage id="header.greeting" />
            <span>,&nbsp;{ownersName}</span>
        </div>
    );
};

GreetingBanner.propTypes = {
    ownersName: PropTypes.string.isRequired,
};

export default GreetingBanner;
